import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubMessaging from './Subcomponents/Messaging';
import withRouter from './Functions/WithRouter';

class AdvMessaging extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }
    }

    componentDidMount() {
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let username = localStorage.getItem('username');
      let orgFocus = localStorage.getItem('orgFocus');
      let activeOrg = localStorage.getItem('activeOrg');
      const orgLogo = localStorage.getItem('orgLogo');

      if (email) {

        let loadPage = true
        let newMessage = false
        if (this.props.location && this.props.location.state) {

          const { threadId, groupPost, generalPost, recipient } = this.props.location.state;

          if (groupPost || generalPost) {
            newMessage = true
          }
          this.setState({ threadId, username, activeOrg, orgFocus, roleName, orgLogo,
            groupPost, generalPost, recipient, loadPage, newMessage })

        } else if (this.props.params) {

          const { threadId } = this.props.params
          this.setState({ threadId, username, activeOrg, orgFocus, loadPage, roleName, orgLogo })

        } else {
          this.setState({ username, activeOrg, orgFocus, roleName, loadPage, orgLogo })
        }
      }
    }

    render() {

      return (
          <div>
              <AppNavigation username={this.state.username} fromAdvisor={true} activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus} roleName={this.state.roleName} history={this.props.navigate} />

              <SubMessaging history={this.props.navigate} groupPost={this.state.groupPost} generalPost={this.state.generalPost} newMessage={this.state.newMessage} recipient={this.state.recipient} />
              <div className="clear" />

              {(this.state.activeOrg) && (
                <div>
                  {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
                </div>
              )}
          </div>

      )
    }
}

export default withRouter(AdvMessaging)
